import { DrawerLayoutWebElementBase } from './DrawerLayoutWebElementBase';

/**
 * The component WebElement for [oj-c-drawer-layout](../../jsdocs/oj-c.DrawerLayout.html).
 * Do not instantiate this class directly, instead, use
 * [findDrawerLayout](../functions/findDrawerLayout.html).
 */
export class DrawerLayoutWebElement extends DrawerLayoutWebElementBase {
  // Put overrides here
}
